<mat-option *ngFor="let element of list"  [value]="element.dd_key">{{element.dd_value_short || element.dd_value}}</mat-option>
